import { render } from "./InstructionsModal.vue?vue&type=template&id=a9394f10&scoped=true"
import script from "./InstructionsModal.vue?vue&type=script&lang=js"
export * from "./InstructionsModal.vue?vue&type=script&lang=js"

import "./InstructionsModal.vue?vue&type=style&index=0&id=a9394f10&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9394f10"]])

export default __exports__